import Footer from "../../footer"
import NavBar from "../../nav"

const ElectronicRecordKeeping = () => {
  return <div className='record-keeping'>
    <NavBar />
    <div>
      <section className="clean-block pfa-content clearfix">
        <div className="divider sections">
          <h1>Electronic Recordkeeping (ERK)</h1>
          <div className="headline-divider sections"></div>
          <h2>Fly Compliant Digital Solutions</h2>
          <h3>One click access to paperless data.</h3>
        </div>
      </section>
      <section className="clean-block clearfix">	
        <div className="container content-container about-container clearfix">
          <div className="feature-image">
            <img className="levelflight-image" src="/assets/img/_web/manuals/iPad_LevelFlight.png" alt="" />
          </div>
          <div className="feature-content">
            <div className="feature-header">Introducing LevelFlight</div>
            <div className="feature-details">Fly Compliant, LLC has developed LevelFlight.com a FAA approved Electronic Recordkeeping (ERK) system meeting requirements per AC 120-78A for pilot records and company manuals. Developed specifically for Part 135 operators our system is capable of supporting any size flight department.</div>
          <div className="prose not-first">As part of LevelFlight, manuals, checklist are maintained and electronically distributed to any iOS  devices with the LevelFlight application</div>	
          <div className="prose not-first"><a href="/contact-us">Contact us</a> for more information on our electronic recordkeeping software, LevelFlight!</div>			
        </div>	
      </div>
      </section>
    </div>
    <Footer />
  </div>
}

export default ElectronicRecordKeeping